import { Component, Element, h } from '@stencil/core';
import {loadInitData} from '../../utils/start';
import { NjRouteProperties } from '../nj-router/NjRouteProperties';
import { manipulateLangNav } from '../../helpers/utils';
import { dataStore, DATA_STORE_KEY_SESSION_CORRUPTED, SessionHealthState } from '../../global/DataStore';
import '@oebb-web-team/oebb-web-components';
import { ReservationMode } from '../nj-reservation/ReservationMode';
import {trackMatomoEvent} from "../../utils/matomo";

@Component({
  tag: 'nj-root',
  styleUrl: 'nj-root.css',
  shadow: true,
})
export class NjAppRoot {

  lang: string;

  @Element() el: HTMLElement;

  routes: NjRouteProperties[] = [
    { path: "/", component: "nj-home" },
    { path: "/home", component: "nj-home" },
    { path: "/reservierung", component: "nj-reservation-root"},
    { path: "/rueckfahrt", component: "nj-reservation", params: { reservationMode: ReservationMode.Return }},
    { path: "/reisende", component: "nj-passanger-data" },
    { path: "/zahlung", component: "nj-payment" },
    { path: "/zusammenfassung", component: "nj-summary" },
    { path: "/ticket", component: "nj-ticket" },
    { path: "/finalize", component: "nj-finalize" },
    { path: "/reduction-cards", component: "nj-reduction-cards" },
    { path: "/connections", component: "nj-connections" },
    { path: "/additional-connections", component: "nj-additional-connections-root" },
    { path: "/notifier/confirm", component: "nj-notifier-confirm" },
    { path: "/notifier/unsubscribe", component: "nj-notifier-unsubscribe" },
  ];

  async componentWillLoad(){
    manipulateLangNav()

    const data = await loadInitData(this.el);
    if (data.publicId) {
      dataStore().setSessionData(DATA_STORE_KEY_SESSION_CORRUPTED, SessionHealthState.OKAY);
    }
  }

  private readonly trackSupportIdPopupClick = () => {
	  trackMatomoEvent({ "event": "nj.support.popupClicked" });
  };

  render() {
    return (
      <div class="base-padding">
        <div>
          <nj-router routes={this.routes}></nj-router>
          <nj-support-id onClick={this.trackSupportIdPopupClick} />
        </div>
      </div>
    );
  }

}
